var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var FavoriteFilled16 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '16px' : _c, _d = _a.width, width = _d === void 0 ? '16px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 16 16", style: svgStyle },
            React.createElement("path", { d: "M8.56 3.013c.76-.862 1.685-1.388 2.772-1.388 1.087 0 1.88.425 2.397 1.128.309.42.459.838.491 1.067.024.063.054.169.082.316.5 2.56-.998 5.988-6.076 9.82L8 14.128l-.226-.17c-5.078-3.833-6.576-7.261-6.076-9.821.028-.147.058-.253.064-.248.05-.297.2-.715.51-1.135.516-.703 1.31-1.128 2.396-1.128 1.087 0 2.011.526 2.773 1.389.21.239.397.49.559.744a5.92 5.92 0 01.56-.745z" }))));
};
FavoriteFilled16.displayName = 'FavoriteFilled16';
export default FavoriteFilled16;
//# sourceMappingURL=favorite-filled-16.js.map